// extracted by mini-css-extract-plugin
module.exports = {"root":"Form_root__1JXzF","inner":"Form_inner__3_7iK","range":"Form_range__NDA7L","name":"Form_name__EoOjl","actions":"Form_actions__ZP_VL"};